import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCode } from '@fortawesome/free-solid-svg-icons';
import { ActionIcon, Modal, Tooltip } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Editor } from '@monaco-editor/react';
import type { ReactNode } from 'react';

import { stringifyJSON } from '@dte/otw-utils-core/src/objects/stringifyJSON';

import { Icon } from '../Spinner/Icon';

/**
 * Abstraction for highlighting JSON
 *
 * @param value - JSON object (or JSON string) to display
 * @returns
 */
export function HighlightJson({ value }: { value: unknown }): ReactNode {
	const stringValue = stringifyJSON(value ?? {});

	return <Editor height="100%" defaultLanguage="json" value={stringValue} options={{ readOnly: true }} />;
}

export interface JsonModalProps {
	title?: string;
	icon?: IconProp;
	value: unknown;
}

export function JsonModal({ title, value, icon }: JsonModalProps): ReactNode {
	const [opened, { open, close }] = useDisclosure(false);

	const titleValue = title ?? 'Debug JSON';
	const iconValue = icon ?? faCode;

	return (
		<>
			<Tooltip
				withArrow={true}
				arrowSize={8}
				arrowOffset={16}
				position="top-start"
				label={titleValue}
				zIndex={9999}
			>
				<ActionIcon onClick={open}>
					<Icon icon={iconValue} aria-label={titleValue} />
				</ActionIcon>
			</Tooltip>
			<Modal opened={opened} onClose={close} title={titleValue} size="90%" centered={true}>
				<div style={{ height: '75vh' }}>
					<HighlightJson value={value} />
				</div>
			</Modal>
		</>
	);
}
